import {Component, OnInit} from '@angular/core';
import {Mail} from '../../../models/models';
import {LoginService} from '../../../services/login.service';
import {CheckService} from '../../../services/check.service';
import {MailService} from '../../../services/mail.service';
import {ColumnModel, EditSettingsModel, ToolbarItems} from '@syncfusion/ej2-angular-grids';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mail-service',
  templateUrl: './mail-service.component.html',
  styleUrls: ['./mail-service.component.css']
})
export class MailServiceComponent implements OnInit {

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private mailService: MailService
  ) { }

  public columns: ColumnModel[];
  public allowPaging = true;
  public pageSettings = true;
  public toolbar: ToolbarItems[];
  public editSettings: EditSettingsModel;
  public dataSource: Mail[] = [];

  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkRightStatus(1);
    this.loadDatasource();
    this.initGrid();
  }

  loadDatasource() {
    this.mailService.getMailServices().subscribe(response => {
      if (response.Ok) {
        this.dataSource = response.Obj;
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire('Interner Server Fehler'); });
  }

  initGrid() {
    this.toolbar = ['Add', 'Edit', 'Delete', 'Cancel', 'Search'];
    this.editSettings =  { allowAdding: true, allowEditing: true, allowDeleting: true, mode: 'Dialog', allowEditOnDblClick: true };
    this.columns = [
      {
        field: 'Id',
        textAlign: 'Left',
        isPrimaryKey: true,
        visible: false,
        defaultValue: '0'
      },
      {
        field: 'Email',
        headerText: 'Email',
        textAlign: 'Left'
      },
      {
        field: 'MailType',
        headerText: 'Typ',
        textAlign: 'Left'
      },
      {
        field: 'Module',
        headerText: 'Modul',
        textAlign: 'Left'
      },
    ];
  }

  actionBegin(args: any) {
    if (args.action === 'add' && args.requestType === 'save') {
      args.cancel = true;
      this.mailService.insertMailService(args.data).subscribe(response => {
        if (!response.Ok && response.Msg === 'Internal Server Error') { console.log(response.Ex); }
        if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      }, error => { this.toast.fire('Interner Serverfehler.'); });
    }
    if (args.action === 'edit' && args.requestType === 'save') {
      this.mailService.updateMailService(args.data.Id, args.data).subscribe(response => {
        if (!response.Ok && response.Msg === 'Internal Server Error') { console.log(response.Ex); }
        if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      }, error => { this.toast.fire('Interner Serverfehler.'); });
    }
    if (args.requestType === 'delete') {
      args.cancel = true;
      Swal.fire({
        title: 'Löschen?',
        text: 'Möchten Sie diese Emailadresse: ' + args.data[0].Email + ' wirklich löschen?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Löschen',
        cancelButtonText: 'Abbrechen',
      }).then((confirmed) => {
        if (confirmed.value) {
          this.mailService.deleteMailService(args.data[0].Id).subscribe(response => {
            if (!response.Ok && response.Msg === 'Internal Server Error') { console.log(response.Ex); }
            if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
          }, error => { this.toast.fire('Interner Serverfehler.'); });
        }
      });
    }
  }
}
